import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="accordion"
export default class extends Controller {
  static targets = ["content", "icon"]

  connect() {
    const params = new URLSearchParams(window.location.search)
    if (params.get("receipt") === "true" || params.get("open") === "true") {
      this.data.set("open", "true")
    }

    // data-accordion-open-value 속성으로 초기 상태 결정 (기본값: false - 접힌 상태)
    const openValue = this.data.get("open")
    const isOpen = openValue === "true"
    
    if (isOpen) {
      this.contentTarget.style.maxHeight = this.contentTarget.scrollHeight + "px"
      this.iconTarget.style.transform = "rotate(180deg)"
    } else {
      this.contentTarget.style.maxHeight = "0px"
      this.contentTarget.classList.add("hidden")
      this.iconTarget.style.transform = "rotate(0deg)"
    }

    // 이벤트 리스너 등록
    this.boundRefreshHeight = this.refreshHeight.bind(this)
    document.addEventListener("accordion:refresh", this.boundRefreshHeight)

    // 전체접기/전체펴기 이벤트 리스너 등록
    this.boundExpandAll = this.expandAll.bind(this)
    this.boundCollapseAll = this.collapseAll.bind(this)
    document.addEventListener("accordion:expandAll", this.boundExpandAll)
    document.addEventListener("accordion:collapseAll", this.boundCollapseAll)

    // 윈도우 리사이즈 이벤트 리스너 등록
    this.boundHandleResize = this.handleResize.bind(this)
    window.addEventListener("resize", this.boundHandleResize)
  }

  disconnect() {
    // 컨트롤러가 해제될 때 이벤트 리스너 제거 (메모리 누수 방지)
    document.removeEventListener("accordion:refresh", this.boundRefreshHeight)
    document.removeEventListener("accordion:expandAll", this.boundExpandAll)
    document.removeEventListener("accordion:collapseAll", this.boundCollapseAll)
    window.removeEventListener("resize", this.boundHandleResize)
  }

  toggle() {
    if (this.contentTarget.classList.contains("hidden")) {
      this.contentTarget.classList.remove("hidden")
      this.contentTarget.style.maxHeight = this.contentTarget.scrollHeight + "px"
      this.iconTarget.style.transform = "rotate(180deg)"
    } else {
      this.contentTarget.style.maxHeight = "0px"
      setTimeout(() => {
        this.contentTarget.classList.add("hidden")
      }, 300)
      this.iconTarget.style.transform = "rotate(0deg)"
    }
  }

  // 전체 펼치기
  expandAll() {
    if (this.contentTarget.classList.contains("hidden")) {
      this.contentTarget.classList.remove("hidden")
      this.contentTarget.style.maxHeight = this.contentTarget.scrollHeight + "px"
      this.iconTarget.style.transform = "rotate(180deg)"
    }
  }

  // 전체 접기
  collapseAll() {
    if (!this.contentTarget.classList.contains("hidden")) {
      this.contentTarget.style.maxHeight = "0px"
      setTimeout(() => {
        this.contentTarget.classList.add("hidden")
      }, 300)
      this.iconTarget.style.transform = "rotate(0deg)"
    }
  }

  refreshHeight() {
    setTimeout(() => {
      // 숨겨지지 않은 컨텐츠에 대해서만 높이 갱신
      if (!this.contentTarget.classList.contains("hidden")) {
        const newHeight = this.contentTarget.scrollHeight
        this.contentTarget.style.maxHeight = newHeight + "px"
      }
    }, 100)
  }

  // 윈도우 크기가 변경될 때 아코디언 높이 조절
  handleResize() {
    // resize 이벤트가 너무 자주 발생하는 것을 방지하기 위한 디바운싱 처리
    if (this.resizeTimeout) {
      clearTimeout(this.resizeTimeout)
    }

    this.resizeTimeout = setTimeout(() => {
      this.refreshHeight()
    }, 100)
  }
}
